import { Fragment, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { XIcon, PlusCircleIcon } from "@heroicons/react/outline";
import { useParams } from "react-router-dom";
import { addSettlement, timelineMessage } from "../../redux/actions/agents";
import { useDispatch } from "react-redux";

export default function AddSettlement({ modal, setModal, loan }) {
  const [settledAmount, setSettledAmount] = useState();
  const [checkProvided, setCheckProvided] = useState(false);
  const [checkRef, setCheckRef] = useState();
  const [date, setDate] = useState();
  const dispatch = useDispatch();

  const { id } = useParams();

  const handleSettlement = (e) => {
    e.preventDefault();

    const message = `Paid a settlement of`;
    const type = `paidSettlement`;
    const amount = `${settledAmount}`;
    dispatch(
      addSettlement({ id, settledAmount, checkProvided, checkRef, date, loan })
    );
    dispatch(timelineMessage({ id, amount, type, message }));

    setModal(false);
  };

  return (
    <Transition.Root show={modal} as={Fragment}>
      <Dialog
        as="div"
        auto-reopen="true"
        className="fixed z-10 inset-0 overflow-y-auto"
        onClose={setModal}
      >
        <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span
            className="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
          >
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div className="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
              <div className="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
                <button
                  type="button"
                  className="bg-white rounded-md text-gray-400 hover:text-gray-500"
                  onClick={() => setModal(false)}
                >
                  <span className="sr-only">Close</span>
                  <XIcon className="h-6 w-6" aria-hidden="true" />
                </button>
              </div>
              <div className="sm:flex sm:items-start">
                <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-sky-100 sm:mx-0 sm:h-10 sm:w-10">
                  <PlusCircleIcon
                    className="h-6 w-6 text-sky-600"
                    aria-hidden="true"
                  />
                </div>
                <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                  <Dialog.Title
                    as="h3"
                    className="text-lg leading-6 font-medium text-gray-900"
                  >
                    Settlement
                  </Dialog.Title>
                  <div className="mt-2 space-y-2">
                    <p className="text-sm text-gray-500">
                      The amount of confirmed settlement
                    </p>
                    <input
                      type="number"
                      name="settledAmount"
                      className="shadow-sm flex-grow  focus:ring-sky-500 focus:border-sky-500 flex w-full sm:w-160 md:w-160 lg:w-160 sm:text-sm border-gray-300 rounded-md placeholder:text-xs"
                      placeholder="Settlement amount"
                      onChange={(e) => setSettledAmount(e.target.value)}
                    />
                    <input
                      type="date"
                      name="date"
                      className="shadow-sm flex-grow  focus:ring-sky-500 focus:border-sky-500 flex w-full sm:w-160 md:w-160 lg:w-160 sm:text-sm border-gray-300 rounded-md"
                      onChange={(e) => setDate(e.target.value)}
                    />
                  </div>
                  <div className="mt-4 space-y-2">
                    <p className="text-sm leading-5 text-gray-500">
                      Did the agent provide check upon paying a settlement?
                    </p>

                    <div className="space-y-4 sm:flex sm:items-center sm:space-y-0 sm:space-x-10">
                      <div className="flex items-center">
                        <input
                          name="notification-method"
                          type="radio"
                          onClick={(e) => setCheckProvided(true)}
                          className="focus:ring-sky-500 h-4 w-4 text-sky-600 border-gray-300"
                        />
                        <span className="ml-3 block text-sm font-medium text-gray-700">
                          yes
                        </span>
                      </div>
                      <div className="flex items-center">
                        <input
                          name="notification-method"
                          type="radio"
                          defaultChecked="true"
                          className="focus:ring-sky-500 h-4 w-4 text-sky-600 border-gray-300"
                          onClick={(e) => setCheckProvided(false)}
                        />
                        <span className="ml-3 block text-sm font-medium text-gray-700">
                          no
                        </span>
                      </div>
                    </div>
                  </div>
                  {checkProvided && (
                    <div className="space-y-2">
                      <p className="text-sm text-gray-500">
                        Check reference code
                      </p>
                      <input
                        type="text"
                        name="checkRef"
                        onChange={(e) => setCheckRef(e.target.value)}
                        className="shadow-sm flex-grow  focus:ring-sky-500 focus:border-sky-500 flex w-full sm:w-160 md:w-160 lg:w-160 sm:text-sm border-gray-300 rounded-md placeholder:text-xs"
                        placeholder="check referenece"
                      />
                    </div>
                  )}
                </div>
              </div>
              <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                <button
                  type="button"
                  className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-sky-600 text-base font-medium text-white hover:bg-sky-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
                  onClick={handleSettlement}
                >
                  Settle
                </button>
                <button
                  type="button"
                  className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500 sm:mt-0 sm:w-auto sm:text-sm"
                  onClick={() => setModal(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
